












































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Airport from "@/store/entities/flight/airport";
import moment from "moment";
import FlightPassenger from "@/store/entities/flight/flightPassengerList";
import ajax from "@/lib/ajax";
import CustomTable from "@/components/customTable.vue";
import SendMailToCustomerModal from "./modals/sendMailToCustomerModal.vue";
@Component({
  components: {
    CustomTable,
    SendMailToCustomerModal
  },
})
export default class FlightPassengerList extends Vue {
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  active_tab: number = 0;
  checkbox: boolean = false;
  isOpenRow: boolean = false;
  radios: boolean = true;
  flightPassenger: FlightPassenger[] = [];
  filterPassengerList: FlightPassenger[] = [];
  startDate: Date = null;
  startDateMenu: boolean = false;
  endDate: Date = null;
  endDateMenu: boolean = false;
  airports: Airport[] = [];
  fromAirport: Airport = new Airport();
  toAirport: Airport = new Airport();
  customerName: string = "";
  flightNo: string = "";
  pnr: string="";
  sendMailModal: boolean = false;
  checkedPassenger: any[] = [];
  totalPax:number=0;
  customerSurname:string="";
  searchKey:string="";
  closeDialog(e) {
    this.sendMailModal = false;
  }
  list(e) {}
  get excel_fields (){
    // regular field (exported data 'as is')
  
     return  {
        "name":"flightNo",
        
        "pnr" : {
                field: 'flightOrders',
                callback: (value) => {
                  for (let index = 0; index < value.length; index++) {
                    return ` ${value[index].orderNo}`;
                    
                  }
                }
     }
    }
   
}
  clearForm(){
    this.pnr="";
    this.customerName="";
    this.customerSurname="";
    this.flightNo="";
    this.startDate=null;
    this.endDate=null;
  }
   tableToExcel = (function() {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  return function(table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
    window.location.href = uri + base64(format(template, ctx))
  }
})()
  
  
  sendEmailInfo() {
    this.sendMailModal = true;
  }
  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }
  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }
  created() {
   
    this.getAirports();
    (this.headers = [
      { text: "PNR", value: "pnr" },
      { text: "Güzergah", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNumber" },
      { text: "Acente", value: "agency" },
      { text: "Operatör", value: "operator" },
      { text: "Operatör PNR", value: "operatorPnr" },
      { text: "Soyadı", value: "surname" },
      { text: "İsim", value: "name" },
      { text: "Cinsiyet", value: "gender" },
    ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Uçuş Yolcu Listesi", disabled: true },
      ]);
  }
  async searchPassengers() {
    this.flightPassenger= [];
    this.totalPax=0;
    const payload = {
      customerName: this.customerName,
      customerSurname: this.customerSurname,
      flightNo:this.flightNo,
      orderNo:this.pnr,
      starts: moment(this.startDate).format("MM-DD-yyyy"),
      ends: moment(this.endDate).format("MM-DD-yyyy"),
    };
    const response = await ajax.get(
      "/api/services/app/Provider/GetFlightPassengers",
      { params: { ...payload } }
    );
    const data = response.data.result.items;
    data.forEach(x => {
      x.flightOrders.forEach(y => {
           y.passengers.forEach(element => {
              this.totalPax+=element.passengers.length;
           });
            });
        });

    const result = this.groupBy(data, "flightNo");
   
for (const index in result) {
  for (let orderDataIndex in result[index]) {
    var flightOrderPassenger: FlightPassenger = new FlightPassenger();
    flightOrderPassenger.flightOrders = [];
    flightOrderPassenger.flightNo = result[index][orderDataIndex].flightNo;
    flightOrderPassenger.flightNo = result[index][orderDataIndex].flightNo;
    flightOrderPassenger.operatorCode = result[index][orderDataIndex].operatorCode;
    flightOrderPassenger.departureDate = result[index][orderDataIndex].departureDate;
    var orders = result[index][orderDataIndex].flightOrders;
    const flightOrders = this.groupBy(orders, "pnr");
    for (let orderIndex in flightOrders) {
      var orderFlightPassenger: FlightPassenger = new FlightPassenger();
      orderFlightPassenger.flightOrders = [];
      orderFlightPassenger.flightNo = result[index][orderDataIndex].flightNo;
      flightOrderPassenger.route = result[index][orderDataIndex].route;
      orderFlightPassenger.operatorCode = result[index][orderDataIndex].operatorCode;
      orderFlightPassenger.departureDate = result[index][orderDataIndex].departureDate;
      orderFlightPassenger.route = flightOrders[orderIndex][0].route;
      for (let dataIndex in flightOrders[orderIndex]) {
        for (let passengerIndex in flightOrders[orderIndex][dataIndex].passengers) {
          var passengerData = flightOrders[orderIndex][dataIndex].passengers[passengerIndex];
          var passenger = Object.assign({}, passengerData.passengers[0]);
          passenger.agency = flightOrders[orderIndex][dataIndex].agency;
          passenger.operator = passengerData.flightProviderQuota;
          passenger.orderId = flightOrders[orderIndex][dataIndex].orderId;
          passenger.orderNo = flightOrders[orderIndex][dataIndex].order.orderNo;
          passenger.flightOrderId = flightOrders[orderIndex][dataIndex].id;
          orderFlightPassenger.flightOrders.push(passenger);
        }
      }
      flightOrderPassenger.flightOrders.push(...orderFlightPassenger.flightOrders);
    }
    this.flightPassenger.push(flightOrderPassenger);
  
}
 
  
}
    console.log(this.flightPassenger);
  }
  groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  async getAirports() {
    await this.$store.dispatch({
      type: "airport/getAirports",
      data: "{}",
    });
    this.airports = this.$store.state.airport.list;
  }
  @Watch("searchKey")
  filterPassengers() {
    if(this.filterPassengerList.length==0){
      this.filterPassengerList=this.flightPassenger;
   // let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.route.includes(this.searchKey.toUpperCase()));
   let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.operatorCode.includes(this.searchKey.toUpperCase())  || x.route.includes(this.searchKey.toUpperCase()) || x.flightOrders.some(y=>y.fullName.toLocaleLowerCase().includes(this.searchKey) || y.fullName.toUpperCase().includes(this.searchKey)  || y.agency.name.toUpperCase().includes(this.searchKey)  || y.agency.name.toLocaleLowerCase().includes(this.searchKey)));
    
   
   this.flightPassenger= filterResults;
    }
    else{
      this.flightPassenger=this.filterPassengerList;
      let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.operatorCode.includes(this.searchKey.toUpperCase()) || x.route.includes(this.searchKey.toUpperCase()) || x.flightOrders.some(y=>y.fullName.toLocaleLowerCase().includes(this.searchKey)  || y.fullName.toUpperCase().includes(this.searchKey )|| y.agency.name.toUpperCase().includes(this.searchKey)  || y.agency.name.toLocaleLowerCase().includes(this.searchKey)));
    this.flightPassenger= filterResults;
    }
 
   
    
  }
}
